import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  saveState<T>(tableId: string, state: Partial<T>): void {
    const key = `state_${tableId}`;
    const dataToSave = {
      ...state,
      _timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(dataToSave));
  }

  getState(tableId: string) {
    const key = `state_${tableId}`;
    const saved = localStorage.getItem(key);
    if (!saved) return null;

    const parsed = JSON.parse(saved);

    if (parsed._timestamp && Date.now() - parsed._timestamp > 24 * 60 * 60 * 1000) {
      this.clearState(tableId);
      return null;
    }

    delete parsed._timestamp;
    return parsed;
  }

  clearState(tableId: string): void {
    localStorage.removeItem(`state_${tableId}`);
  }

  clearAllStates(): void {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith('state_')) {
        localStorage.removeItem(key);
      }
    });
  }
}
